import { render, staticRenderFns } from "./reviewDetails_wx.vue?vue&type=template&id=1c34b7d2&scoped=true"
import script from "./reviewDetails_wx.vue?vue&type=script&lang=js"
export * from "./reviewDetails_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c34b7d2",
  null
  
)

export default component.exports